import { Box, Button, Divider, Paper, Typography, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useToast } from 'use-toast-mui';
import AnimationPage from '../../pages/AnimationPage';
import { errorMessages } from '../../utils/methods';
import { FormInputDropdown } from '../form/FormInputDropdown';
import { useForm } from 'react-hook-form';
import DeleteForeverIcon from '@mui/icons-material/DeleteOutline';
import { FormInputText } from '../../form-components/FormInputText';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getBannerById, deleteBannerById, updateBanner } from '../../api/ticket';
import BannerDeleteModal from './BannerDeleteModal';

const positionType = [
  { label: 'MAIN_01', value: 'MAIN_01' },
  { label: 'MAIN_02', value: 'MAIN_02' },
  { label: 'MAIN_03', value: 'MAIN_03' },
  { label: 'MAIN_04', value: 'MAIN_04' },
  { label: 'MAIN_05', value: 'MAIN_05' },
  { label: 'MAIN_06', value: 'MAIN_06' },
  { label: 'MAIN_07', value: 'MAIN_07' },
  { label: 'MAIN_08', value: 'MAIN_08' },
  { label: 'MAIN_09', value: 'MAIN_09' },
  { label: 'MAIN_10', value: 'MAIN_10' },
];
const statusType = [
  {
    label: 'POSTING',
    value: 'POSTING',
  },
  {
    label: 'HIDDEN',
    value: 'HIDDEN',
  },
];

const bannerType = [
  {
    label: 'BRANCH',
    value: 'BRANCH',
  },
  {
    label: 'TICKET',
    value: 'TICKET',
  },
  {
    label: 'PASS',
    value: 'PASS',
  },
  {
    label: 'ADS',
    value: 'ADS',
  },
];

const DetailBanner = () => {
  const { t } = useTranslation();
  const token = useSelector(function (state) {
    return state.user.user.token;
  });

  const toast = useToast();
  const [bannerDetail, setBannerDetail] = useState({});
  const user = useSelector(state => state.user.user);
  const { handleSubmit, control, reset, watch, getValues } = useForm({ defaultValues: bannerDetail });
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const { id } = useParams();

  const getBanner = async () => {
    try {
      const data = await getBannerById(id, token);
      setVideoThumbnail({ file: null, url: data?.imageUrl });
      reset(data);
      setBannerDetail(data);
    } catch (error) {
      console.error('API call failed:', error);
      toast.error(errorMessages(error));
    }
  };

  const [videoThumbnail, setVideoThumbnail] = useState({ file: null, url: null });

  const submit = async values => {
    setLoader(true);
    const formData = new FormData();
    Object.keys(values).forEach(key => {
      formData.append(key, values[key]);
    });

    values.landingType === 'ADS' ? formData.delete('landingId') : formData.delete('landingLink');
    formData.append('bannerLandingType', values.landingType);

    if (videoThumbnail.file) {
      formData.append('image', videoThumbnail.file);
    } else if (videoThumbnail.url) {
      formData.append('imageString', videoThumbnail.url === null ? '' : videoThumbnail.url);
    }

    try {
      await updateBanner(id, formData, user.token);
      toast.success(t('Banner updated successfully'));
      navigate('/banner');
    } catch (error) {
      toast.error(errorMessages(error));
      setLoader(false);
    }
  };

  const deleteVideoThumbnail = e => {
    e.preventDefault();
    setVideoThumbnail({ file: null, url: null });

    const fileInput = document.getElementById('video-thumbnail');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleUploadVideoThumbnail = async event => {
    try {
      const file = event.target.files[0];

      if (file) {
        const validFileTypes = ['image/png', 'image/jpeg'];
        if (!validFileTypes.includes(file.type)) {
          toast.error(t('Only PNG and JPG files are allowed'));
          return;
        }

        const imageURL = URL.createObjectURL(file);
        const img = new Image();

        img.src = imageURL;

        img.onload = () => {
          if (img.width <= 686 && img.height <= 310) {
            setVideoThumbnail({ file: file, url: imageURL });
          } else {
            toast.error(t('Image exceeds the maximum allowed dimensions of 686x310'));
          }
        };
      }
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const deleteBanner = async () => {
    try {
      await deleteBannerById(id, user.token);
      toast.success(t('Banner(s) Deleted'));
      navigate('/banner');
    } catch (error) {
      toast.error(errorMessages(error));
      setLoader(false);
    }
  };

  useEffect(() => {
    // console.log(getValues('imageText')?.length);
  }, [watch('imageText')]);

  useEffect(() => {
    getBanner();
  }, []);
  return (
    <AnimationPage>
      <Box
        component={Paper}
        elavation={2}
        sx={{
          background: '#fff',
          borderRadius: '10px',
          padding: '30px 40px',
          width: '1080px',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
            {t('State')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('전체')}</MenuItem>}
            name="status"
            rules={{ required: true }}
            control={control}
            options={statusType}
            // value={ticketData?.sportType}
            sx={{ width: '114px', mr: 2 }}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
            {t('Position')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('전체')}</MenuItem>}
            name="position"
            rules={{ required: true }}
            control={control}
            options={positionType}
            // value={ticketData?.sportType}
            sx={{ width: '114px', mr: 2 }}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: '20px',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
              {t('Title')}
            </Typography>

            <FormInputText
              color="info"
              sx={{ width: '375px' }}
              size="small"
              placeholder="제목을 입력해 주세요"
              id="outlined-search"
              type="search"
              name="title"
              rules={{ required: true }}
              control={control}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '20px' }}>
          <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
            {t('Landing Type')}
          </Typography>
          <FormInputDropdown
            disabledItem={<MenuItem disabled>{t('전체')}</MenuItem>}
            name="landingType"
            rules={{ required: true }}
            control={control}
            options={bannerType}
            // value={ticketData?.sportType}
            sx={{ width: '114px', mr: 2 }}
          />
        </Box>
        {watch('landingType') === 'ADS' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: '20px',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
                {t('Landing Link')}
              </Typography>

              <FormInputText
                color="info"
                sx={{ width: '375px' }}
                size="small"
                placeholder="링크를 입력해 주세요"
                id="outlined-search"
                type="search"
                name="landingLink"
                rules={{}}
                control={control}
              />
            </Box>
          </Box>
        )}
        {watch('landingType') !== 'ADS' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: '20px',
            }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
                {t('Landing ID')}
              </Typography>

              <FormInputText
                color="info"
                sx={{
                  width: '375px',
                  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                    display: 'none',
                  },
                  '& input[type=number]': {
                    MozAppearance: 'textfield',
                  },
                }}
                size="small"
                placeholder="링크를 입력해 주세요"
                id="outlined-search"
                type={watch('landingType') === 'ADS' ? 'search' : 'number'}
                name="landingId"
                rules={{}}
                control={control}
              />
            </Box>
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: '20px',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
              {t('Upload an image')}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row',
                border: '1px solid #ddd',
                height: '245px',
                width: '293px',
                mt: 1,
                mb: 1,
                borderRadius: '5px',
              }}>
              <Box
                sx={{
                  background: '#C1DBDE',
                  width: '240px',
                  height: '181px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  overflow: 'hidden',
                }}>
                <label
                  htmlFor="video-thumbnail"
                  style={{
                    cursor: 'pointer',
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  {videoThumbnail?.url || videoThumbnail?.file ? (
                    <>
                      <img src={videoThumbnail.url} style={{ height: '100%' }} />
                      <Button
                        style={{
                          position: 'absolute',
                          display: 'flex',
                          minWidth: 'unset',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#fff',
                          bottom: '7px',
                          right: '7px',
                          padding: '4px',
                        }}
                        onClick={e => deleteVideoThumbnail(e)}>
                        <DeleteForeverIcon sx={{ fontSize: '20px', color: '#000' }} />
                      </Button>
                    </>
                  ) : (
                    <img src="/images/icons/image-icon.png" width={40} height={44} alt="Upload video thumbnail" />
                  )}
                </label>
                <input
                  type="file"
                  id="video-thumbnail"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleUploadVideoThumbnail}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', height: '100%' }}>
              <Typography sx={{ fontSize: '11px', alignSelf: 'center', ml: 1 }}>( 686 x 310px )</Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mt: '20px',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography className="title" sx={{ mr: '20px', fontSize: '12px', fontWeight: 500, width: '75px' }}>
              {t('Image post')}
            </Typography>

            <FormInputText
              color="info"
              sx={{ width: '375px' }}
              size="small"
              placeholder="내용을 입력해 주세요"
              id="outlined-search"
              type="search"
              name="imageText"
              rules={{}}
              inputProps={{ maxLength: '15' }}
              control={control}
            />
            <Typography sx={{ fontSize: '11px', alignSelf: 'center', ml: 1 }}>
              ({getValues('imageText')?.length ?? 0}/15)
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ mb: '20px', mt: '26px', color: '#e1e1e1' }} />

        <Box
          sx={{
            display: 'flex',
            mt: '10px',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}>
          <Button
            onClick={() => setOpen(true)}
            sx={{
              p: '12px 37px 11px 37px',
              borderRadius: '5px',
              height: '36px',
              width: '100px',
              background: 'transparent',
              border: '1px solid #FF3A29',
              color: '#FF3A29',
              '&:hover': { background: '#ddd' },
            }}>
            {t('Delete')}
          </Button>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              columnGap: '6px',
            }}>
            <Button
              onClick={() => console.log('hello')}
              sx={{
                p: '12px 37px 11px 37px',
                borderRadius: '5px',
                height: '36px',
                width: '100px',
                background: '#98A6AD',
                color: '#fff',
                '&:hover': { background: '#ddd' },
              }}>
              {t('Cancel')}
            </Button>
            <Button
              onClick={handleSubmit(submit)}
              disabled={loader}
              sx={{
                p: '12px 56px 11px 55px',
                borderRadius: '5px',
                height: '36px',
                width: '137px',
                background: '#0F7F85',
                color: '#fff',
                '&:hover': { background: '#0F7F85', color: '#fff' },
              }}>
              {t('Save')}
            </Button>
          </Box>
        </Box>
        <BannerDeleteModal open={open} setOpen={setOpen} handleDelete={deleteBanner} />
      </Box>
    </AnimationPage>
  );
};

export default DetailBanner;
